<div class="minesweeper size-{{fieldSize}}">
    <div class="row" *ngFor="let row of field">
        <ridango-msw-tile *ngFor="let item of row" [tile]="item" (onTileClick)="tileCicked($event)"></ridango-msw-tile>
    </div>
</div>
<!-- <button *ngIf="gameOver" (click)="restart()">Restart</button> -->
